export type AlignmentEnumType =
  (typeof AlignmentEnum)[keyof typeof AlignmentEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlignmentEnum = {
  bannerOn: "bannerOn",
  bannerOff: "bannerOff",
  null: null,
} as const;
